import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { fetchSkins } from "../../../actions/roblox/skinsActions";
import { useAppDispatch } from "../../../store/hooks";
import { queryParams } from "../../../helpers/UrlHelpers";
import robloxUrls from "../../../configs/roblox/robloxUrls";

import PageLayout from "../_partials/PageLayout";
import PageHeader from "../Skins/_partials/_PageHeader";
import List from "../Skins/_partials/_List";
import Wrapper from "../../../componets/Wrapper";
import Filter, { FilterInterface } from "../../../componets/Filter";
import New from "../../roblox/Skins/New";
import ListViewButtons from "../../../componets/ListViewButtons";

interface PropsInterface {
  collection?: 'pants' | 'shirts' | 't_shirts' | 'posts';
}

const NAV_ITEMS: {[index: number]: any} = {
  0: {
    id: 0,
    name: 'Pants',
    url: robloxUrls.communityPantsPath()
  },
  1: {
    id: 1,
    name: 'Shirts',
    url: robloxUrls.communityShirtsPath()
  },
  2: {
    id: 2,
    name: 'T-shirts',
    url: robloxUrls.communityTshirtsPath()
  },
  3: {
    id: 3,
    name: 'Posts',
    url: robloxUrls.communityPostsPath()
  },
};
const LIMIT = 42;
const DEFAULT_VIEW = 'grid';

const Community = ({ collection }: PropsInterface) => {
  const dispatch  = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const listType: any = queryParams.get(searchParams,'view') || DEFAULT_VIEW;
  const filterProps: FilterInterface = {};

  useEffect(() => {
    const params: any = queryParams.requestParams(
        searchParams,
        {
          limit: LIMIT,
          offset: (currentPage - 1) * LIMIT
        },
        ['term', 'order_by', 'order', 'date_from', 'date_to']
    );

    dispatch(fetchSkins({ params, target: 'community', collection }));
  }, [collection, searchParams, currentPage, dispatch]);

  filterProps.orderBy = {
    defaultKey: 'id',
    defaultSort: 'desc',
    items: [
      { name: 'Date',       key: 'id' },
      { name: 'Popular',    key: 'popular_count' },
      { name: 'Likes',      key: 'likes_count' },
      { name: 'Comments',   key: 'comments_count' },
      { name: 'Downloads',  key: 'downloads_count' },
    ]
  };

  return (
      <PageLayout>
        <PageHeader
            title={'Community'}
            navs={NAV_ITEMS}
            parent={{
              name: 'All',
              url: robloxUrls.communityPath()
            }}
        />

        <div className='v-container'>
          <Wrapper type='type-1' border className='v-mb-10'>
            <Filter
                search
                dateRange
                {...filterProps}
            >
              <ListViewButtons className='v-mb-5' align='right' defaultType={DEFAULT_VIEW} />
            </Filter>
          </Wrapper>

          <List limit={LIMIT} pagination={true} type={listType} />

          <New />
        </div>
      </PageLayout>
  );
}

export default Community;
